import * as Types from '../../../../../../__generated__/base.gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type DisconnectFromOrganisationPriceListMutationVariables = Types.Exact<{
  priceListId: Types.Scalars['ID'];
}>;


export type DisconnectFromOrganisationPriceListMutation = { readonly __typename?: 'Mutation', readonly priceListV2: { readonly __typename?: 'PriceListV2Mutations', readonly disconnectFromOrganisationPriceList: { readonly __typename?: 'DisconnectOrganisationPriceListResponse', readonly priceListId: string } } };


export const DisconnectFromOrganisationPriceListDocument = gql`
    mutation disconnectFromOrganisationPriceList($priceListId: ID!) {
  priceListV2 {
    disconnectFromOrganisationPriceList(input: {priceListId: $priceListId}) {
      priceListId
    }
  }
}
    `;
export type DisconnectFromOrganisationPriceListMutationFn = Apollo.MutationFunction<DisconnectFromOrganisationPriceListMutation, DisconnectFromOrganisationPriceListMutationVariables>;

/**
 * __useDisconnectFromOrganisationPriceListMutation__
 *
 * To run a mutation, you first call `useDisconnectFromOrganisationPriceListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisconnectFromOrganisationPriceListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disconnectFromOrganisationPriceListMutation, { data, loading, error }] = useDisconnectFromOrganisationPriceListMutation({
 *   variables: {
 *      priceListId: // value for 'priceListId'
 *   },
 * });
 */
export function useDisconnectFromOrganisationPriceListMutation(baseOptions?: Apollo.MutationHookOptions<DisconnectFromOrganisationPriceListMutation, DisconnectFromOrganisationPriceListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DisconnectFromOrganisationPriceListMutation, DisconnectFromOrganisationPriceListMutationVariables>(DisconnectFromOrganisationPriceListDocument, options);
      }
export type DisconnectFromOrganisationPriceListMutationHookResult = ReturnType<typeof useDisconnectFromOrganisationPriceListMutation>;
export type DisconnectFromOrganisationPriceListMutationResult = Apollo.MutationResult<DisconnectFromOrganisationPriceListMutation>;
export type DisconnectFromOrganisationPriceListMutationOptions = Apollo.BaseMutationOptions<DisconnectFromOrganisationPriceListMutation, DisconnectFromOrganisationPriceListMutationVariables>;